export default __webpack_public_path__ + "static/media/IndependenceNew4.9f1bec14.JPG";